import { buildAgentQuestionAnsweredBlocks } from './buildAgentQuestionAnsweredBlocks.js'

export function markAgentQuestionAnswered(message, answer) {
  const question = message?.agentQuestion
  if (!question || question.status !== 'open') return message
  return {
    ...message,
    text: '',
    agentQuestion: {
      ...question,
      status: 'answered',
      answer,
      answeredAt: Date.now(),
    },
    blocks: buildAgentQuestionAnsweredBlocks(question, answer),
  }
}

export function markOpenAgentQuestionAnsweredBeforeSend(params) {
  const { setMessagesByThreadId, threadId, answer } = params
  if (!threadId || !answer?.sendText) return
  setMessagesByThreadId((prev) => {
    const list = [...(prev[threadId] ?? [])]
    const idx = list.findLastIndex((msg) => msg.agentQuestion?.status === 'open')
    if (idx === -1) return prev
    list[idx] = markAgentQuestionAnswered(list[idx], answer)
    return { ...prev, [threadId]: list }
  })
}
